<template>
  <div class="mdc-card mgb-24 pda-24">
    <div class="t-headline7 font-m">
      습득할 수 있는 역량
    </div>
    <div v-for="(skill, index) in skillset" :key="index" class="mdc-chip-set mgl--8 mgt-16" role="grid">
      <div class="mdc-chip h-32 t-line-h-initial  bg-primarySelected" role="row">
        <span role="gridcell">
            <span class="mdc-chip__primary-action" role="button" tabindex="0">
              <span class="mdc-chip__text t-body4 pdt-2 t-color-primary font-r">{{ skill.name }}</span>
              </span>
            </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SkillSet",

  props: ['skillset'],

}
</script>

<style scoped>

</style>
